import { render, staticRenderFns } from "./EventsCategories.vue?vue&type=template&id=6fe7fd9b&scoped=true"
import script from "./EventsCategories.vue?vue&type=script&lang=js"
export * from "./EventsCategories.vue?vue&type=script&lang=js"
import style0 from "./EventsCategories.vue?vue&type=style&index=0&id=6fe7fd9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe7fd9b",
  null
  
)

export default component.exports